import { render, staticRenderFns } from "./CalendarEmbed.vue?vue&type=template&id=6853e53e&scoped=true"
import script from "./CalendarEmbed.vue?vue&type=script&lang=js"
export * from "./CalendarEmbed.vue?vue&type=script&lang=js"
import style0 from "./CalendarEmbed.vue?vue&type=style&index=0&id=6853e53e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6853e53e",
  null
  
)

export default component.exports